<template>
  <div class="tracking-root">
    <div class="headerBar">
      <el-button
        class="back-button"
        type="primary"
        @click="back"
        v-if="!isSuccess"
        >返回</el-button
      >
    </div>
    <div class="tipsText top-gap">
      还剩下{{ frequency < 0 ? 0 : frequency }}次人脸核身次数
    </div>
    <div class="drawerTracking">
      <VideoCanvas
        :mediaConstraints="mediaConstraints"
        :examinationId="$route.query.examinationId"
        @success="success"
        @error="error"
      />
    </div>
    <div class="buttons">
      <el-button class="button" type="primary" @click="enter" v-if="isSuccess"
        >进入考场</el-button
      >
    </div>
  </div>
</template>

<script>
require("tracking/build/tracking-min.js");
require("tracking/build/data/face-min.js");
import VideoCanvas from "./VideoCanvas.vue";
export default {
  name: "testTracking",
  props: ["mediaConstraints"],
  data() {
    return {
      count: 0,
      isSuccess: false,
      frequency: 0,
      isHttps: false,
      reacquireDisabled: false,
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    isNuclear(state) {
      this.reacquireDisabled = state;
    },
    initData(cb) {
      const examinationId = this.$route.query.examinationId;
      this.isHttps = true;
      this.$https
        .get("/api/my/exam/list")
        .then((res) => {
          this.isHttps = false;
          if (res.success) {
            const data = res.data;
            let frequency = Number(this.$route.query.verifyNum || 0);
            for (let el of data) {
              if (el.examinationId == examinationId) {
                frequency = el.verifyNum;
                break;
              }
            }
            this.frequency = frequency;
            if (cb) {
              cb();
            }
          }
        })
        .catch(() => {
          this.isHttps = false;
        });
    },
    enter() {
      this.$emit("success");
    },
    success(res) {
      this.frequency--;
      this.isSuccess = true;
      this.$message.success("认证成功");
    },
    error() {
      this.frequency--;
    },
    back() {
      this.$emit("onBack");
    },
  },
  components: {
    VideoCanvas,
  },
};
</script>

<style scoped>
.tracking-root {
  position: relative;
}
.headerBar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px 0 16px;
}
.back-button {
  margin: 0;
}
.tipsText {
  text-align: center;
  font-size: 25px;
  color: red;
}
.top-gap {
  margin-top: 12px; /* 与左上角按钮形成间隙 */
}
.buttons {
  display: flex;
}
.button {
  flex: 0 0 150px;
  margin: 15px auto;
  cursor: pointer;
}
</style>
